// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"479a34cd","455":"588ec4e6","977":"12066f81"}[chunkId] + ".chunk.js";
};